import React from 'react';
import { FadeIn } from './FadeIn';
import { HeartIcon, CalendarIcon, CompassIcon, BookOpenIcon } from 'lucide-react';
const blocks = [{
  icon: HeartIcon,
  title: 'No necesitás dejarlo llorar',
  text: 'El método está pensado para acompañar el sueño de tu bebé sin recurrir al llanto prolongado.'
}, {
  icon: CalendarIcon,
  title: 'No necesitás rutinas imposibles',
  text: 'Vas a aplicar pasos simples y realistas, pensados para una mamá cansada y una casa real.'
}, {
  icon: CompassIcon,
  title: 'No necesitás adivinar qué hacer',
  text: 'La guía te muestra qué mirar, qué ajustar y cómo actuar sin sentirte perdida.'
}, {
  icon: BookOpenIcon,
  title: 'Sí necesitás una guía clara',
  text: 'Cuando entendés qué está pasando y cómo acompañarlo, todo empieza a sentirse más liviano.'
}];
export function TrustSection() {
  return <section className="bg-cream py-24 px-6 md:px-12" data-id="element-145">
      <div className="max-w-6xl mx-auto" data-id="element-146">
        <FadeIn data-id="element-147">
          <h2 className="text-4xl md:text-5xl text-center mb-4" data-id="element-148">
            Por qué este método se siente distinto
          </h2>
          <p className="text-lg md:text-xl text-brown/60 text-center max-w-2xl mx-auto mb-16" data-id="element-149">
            No se trata de hacerlo perfecto. Se trata de acompañar mejor, con
            más claridad y menos angustia.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-150">
          {blocks.map((block, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-151">
              <div className="bg-white p-8 rounded-3xl shadow-sm border border-brown/5 h-full" data-id="element-152">
                <block.icon className="w-8 h-8 text-periwinkle mb-5" data-id="element-153" />
                <h3 className="text-xl font-bold mb-3 text-brown" data-id="element-154">
                  {block.title}
                </h3>
                <p className="text-brown/70 text-lg leading-relaxed" data-id="element-155">
                  {block.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}